<template>
  <div>
    <page-header>
      <div class="boardTitle mt-3 mr-3 ml-3 font-weight-bold align-self-center">
        {{ boardTitle }}
      </div>
      <router-link class="mt-3 mb-1" :to="{ name: 'Board', params: { id: $route.params.id } }">
        <div class="badgebutton active text-nowrap c-white">
          <i class="far fa-clock"></i>
          Back to Board
        </div>
      </router-link>
    </page-header>

    <div class="board-overview-container">
      <BoardOverview />
    </div>

    <AppInfo />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import BoardOverview from '@/components/Overview/BoardOverview.vue';
  import { BoardModule, BoardStore } from '@/store/board';

  @Component({
    components: {
      PageHeader,
      BoardOverview,
    },
  })
  export default class BoardOverviewComponent extends Vue {
    private boardStore: BoardModule = BoardStore;

    get boardTitle() {
      return this.boardStore.board.title;
    }

    async mounted() {
      await this.boardStore.getBoard(this.$route.params.id);
    }
  }
</script>

<style lang="scss" scoped>
  .board-overview-container {
    margin: 1em;
    padding: 1.5rem;
    background-color: rgba(248, 248, 248, 0.9);
    background-blend-mode: difference;
    border-radius: 4px;
  }
</style>
